import { subjects } from 'shared/constants/subjects';
import { grades } from 'shared/constants/grades';

export const Subjects = [
  {
    name: 'Все предметы',
    imageName: 'all',
    link: '',
  },
  ...subjects,
];

export const CategoriesGrades = [{ value: '', label: 'Все классы' }, ...grades];
